import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Iterable, Map } from 'immutable';
import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../../../config/constants';

import Image from '..';

/**
 * @deprecated use ImageFromField from react-drupal-core instead
 * @returns {void}
 */
const ImageFromField = ({ field, className, src, imageStyles, lazyload }) => {
  const getImageStyle = (style) => {
    const imageStyle = field.getIn(['styles', style]);
    if (!imageStyle) {
      console.error(`The image style "${style}" is not available`, field.toJS());
    }

    return imageStyle;
  };

  let sources = Map({
    [SCREEN_MOBILE]: getImageStyle('crop_standard'),
    [SCREEN_TABLET]: getImageStyle('crop_standard'),
    [SCREEN_NORMAL]: getImageStyle('crop_standard'),
    [SCREEN_WIDE]: getImageStyle('crop_standard'),
    [SCREEN_HUGE]: getImageStyle('crop_standard'),
  });

  if (Iterable.isIterable(imageStyles) && imageStyles.size > 0) {
    sources = imageStyles.map((style) => getImageStyle(style));
  } else if (typeof imageStyles === 'string') {
    sources = getImageStyle(imageStyles);
  } else if (typeof src === 'string') {
    sources = src;
  }

  return (
    <Image
      src={sources}
      className={className}
      alt={field.get('alt')}
      title={field.get('title')}
      // width={field.get('width')}
      // height={field.get('height')}
      lazyload={lazyload}
      includeWebP
    />
  );
};

ImageFromField.propTypes = {
  imageStyles: PropTypes.oneOfType([
    PropTypes.string,
    ImmutablePropTypes.map,
  ]),
  src: PropTypes.string,
  field: ImmutablePropTypes.map,
};

ImageFromField.defaultProps = {
  imageStyles: Map(),
  src: null,
  field: Map(),
};

export default ImageFromField;
